(function () {
  'use strict';
  var d = document;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };
  function once(el, key) { if (el['_' + key]) return false; el['_' + key] = true; return true; }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var track = $('[data-track]', root);
    if (!track) return;
    var slides = $$('.gallery__slide', track);
    var dots = $$('[data-dot]', root);
    var thumbs = $$('[data-thumb]', root);
    var counter = $('[data-counter]', root);
    var index = 0;

    function paint(i) {
      index = i;
      dots.forEach(function (x, n) { n === i ? x.setAttribute('aria-current', 'true') : x.removeAttribute('aria-current'); });
      thumbs.forEach(function (t, n) { n === i ? t.setAttribute('aria-current', 'true') : t.removeAttribute('aria-current'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
      paint(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index && slides[i]) paint(i);
      });
    }, { passive: true });

    var prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { go(n); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index + 1); }
    });
  }

  /* ---------- Variants (also keeps the sticky bar in sync) ---------- */
  function initVariants(root) {
    var dataEl = $('[data-variants]', root);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var radios = $$('input[type=radio][name=id]', root);
    if (!radios.length) return;

    var price = $('[data-price]', root), compare = $('[data-compare]', root), save = $('[data-save]', root);
    var avail = $('[data-availability]', root), buy = $('[data-buy]', root), add = $('[data-add]', root);
    var stock = $('[data-stock]', root);
    var sPrice = $('[data-sticky-price]', root), sBuy = $('[data-sticky-buy]', root);

    function update(v) {
      if (!v) return;
      price.textContent = v.price;
      if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
      if (save) { save.textContent = 'Save ' + v.save + '%'; save.hidden = !v.compare; }
      avail.textContent = v.available ? 'In stock' : 'Sold out';
      avail.classList.toggle('is-out', !v.available);
      buy.disabled = !v.available;
      buy.textContent = v.available ? buy.getAttribute('data-label') : 'Sold out';
      if (add) add.disabled = !v.available;
      if (sPrice) sPrice.textContent = v.price;
      if (sBuy) {
        sBuy.disabled = !v.available;
        sBuy.textContent = v.available ? sBuy.getAttribute('data-label') : 'Sold out';
      }
      if (stock) {
        var threshold = parseInt(stock.getAttribute('data-threshold'), 10) || 20;
        var show = v.stock !== null && v.stock > 0 && v.stock <= threshold;
        stock.hidden = !show;
        if (show) {
          $('[data-stock-text]', stock).textContent = stock.getAttribute('data-text').replace('[count]', v.stock);
          $('[data-stock-bar]', stock).style.width = Math.round(v.stock * 100 / threshold) + '%';
        }
      }
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      } catch (e) {}
    }
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        var id = parseInt(r.value, 10);
        update(variants.filter(function (v) { return v.id === id; })[0]);
      });
    });
  }

  /* ---------- Buy now: straight to checkout, never the cart ---------- */
  function initBuyNow(root) {
    var form = $('form.buy', root);
    if (!form || !once(form, 'buynow')) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var busy = false;
    form.addEventListener('submit', function (e) {
      if (busy) { e.preventDefault(); return; }
      if (!window.fetch || !window.FormData) return; // plain form post still returns to /checkout
      e.preventDefault();
      busy = true;
      var btn = $('[data-buy]', form);
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Please wait…'; }
      var body = new FormData(form);
      body.delete('return_to'); body.delete('checkout');
      var json = { headers: { 'Accept': 'application/json' } };
      // start from an empty cart so checkout only contains this product
      fetch(base + 'cart/clear.js', { method: 'POST', headers: json.headers })
        .catch(function () {})
        .then(function () { return fetch(base + 'cart/add.js', { method: 'POST', body: body, headers: json.headers }); })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); window.location.href = base + 'checkout'; })
        .catch(function () {
          busy = false;
          if (btn) { btn.disabled = false; btn.textContent = label; }
          form.submit(); // fallback: normal post, redirects to /checkout via return_to
        });
    });
  }

  /* ---------- Delivery estimate ---------- */
  function initDelivery(root) {
    var el = $('[data-delivery]', root);
    if (!el) return;
    var min = parseInt(el.getAttribute('data-min'), 10), max = parseInt(el.getAttribute('data-max'), 10);
    if (!min || !max) return;
    var fmt;
    try { fmt = new Intl.DateTimeFormat(d.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short' }); }
    catch (e) { return; }
    var day = function (n) { var t = new Date(); t.setDate(t.getDate() + n); return fmt.format(t); };
    $('[data-delivery-range]', el).textContent = day(min) + ' – ' + day(max);
  }

  /* ---------- Sticky buy bar: appears once the visitor scrolls, shakes after a delay ---------- */
  function initSticky(root) {
    var bar = $('[data-sticky-cta]', root);
    if (!bar) return;
    var btn = $('[data-sticky-buy]', bar);
    var main = $('[data-buy]', root);
    var shakeOn = bar.getAttribute('data-shake') === 'true';
    var shakeDelay = Math.max(1, parseFloat(bar.getAttribute('data-shake-delay')) || 5) * 1000;
    var on = false, shakeTimer = null;

    d.body.classList.add('has-sticky');

    if (btn && main) btn.addEventListener('click', function () { if (!main.disabled) main.click(); });

    function show(flag) {
      if (flag === on) return;
      on = flag;
      bar.classList.toggle('is-on', flag);
      bar.setAttribute('aria-hidden', flag ? 'false' : 'true');
      d.body.classList.toggle('sticky-visible', flag);
      clearTimeout(shakeTimer);
      bar.classList.remove('is-shaking');
      if (flag && shakeOn && !reduce) shakeTimer = setTimeout(function () { bar.classList.add('is-shaking'); }, shakeDelay);
    }
    // Show the sticky bar only while the buy card's own Buy Now button is off screen.
    function buyVisible() {
      if (!main || main.offsetParent === null) return false;
      var r = main.getBoundingClientRect();
      var top = parseFloat(getComputedStyle(d.documentElement).getPropertyValue('--topbar-h')) || 0;
      return r.bottom > top && r.top < (window.innerHeight || d.documentElement.clientHeight);
    }
    function update() {
      var scrolled = (window.pageYOffset || d.documentElement.scrollTop || 0) > 80;
      show(scrolled && !buyVisible());
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Countdown (counts down to a real end date; used in the top bar and product card) ---------- */
  function initCountdown(el) {
    var end;
    if (el.getAttribute('data-mode') === 'visitor') {
      // Each visitor gets their own timer, started on their first visit and remembered in this browser.
      var mins = Math.max(1, parseFloat(el.getAttribute('data-minutes')) || 30);
      var resetH = parseFloat(el.getAttribute('data-reset'));
      var resetMs = (isNaN(resetH) ? 24 : resetH) * 3600000;
      var storeKey = 'parcelTimer:' + (el.getAttribute('data-key') || 'main');
      var now = Date.now(), startAt = NaN;
      try { startAt = parseInt(localStorage.getItem(storeKey), 10); } catch (e) {}
      var over = !isNaN(startAt) && now > startAt + mins * 60000;
      if (isNaN(startAt) || startAt > now || (over && resetMs > 0 && now > startAt + mins * 60000 + resetMs)) {
        startAt = now;
        try { localStorage.setItem(storeKey, String(startAt)); } catch (e) {}
      }
      end = startAt + mins * 60000;
    } else {
      end = Date.parse(el.getAttribute('data-end'));
    }
    var out = $('[data-countdown-time]', el);
    if (isNaN(end) || end <= Date.now() || !out) return;
    var segments = el.classList.contains('timerbar');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { el.hidden = true; return; }
      var days = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600),
          m = Math.floor(left % 3600 / 60), s = left % 60;
      var parts = [pad(h), pad(m), pad(s)];
      if (days > 0) parts.unshift(days + 'd');
      if (segments) out.innerHTML = '<b>' + parts.join('</b><em>:</em><b>') + '</b>';
      else out.textContent = parts.join(' : ');
      setTimeout(tick, 1000);
    }
    el.hidden = false;
    tick();
  }

  /* ---------- Fixed top bars: keep other things clear of them ---------- */
  function initTopbar() {
    var bar = $('[data-topbar]');
    var proof = $('[data-proof]');
    if (!bar && !proof) return;
    var key = bar || proof;
    if (!once(key, 'init')) return;
    function fixedHeight(el) {
      if (!el || el.getAttribute('data-sticky') !== 'true') return 0;
      var wrap = el.closest('.shopify-section') || el;
      return Math.ceil(wrap.getBoundingClientRect().height);
    }
    function measure() {
      var p = fixedHeight(proof), t = fixedHeight(bar), h = p + t;
      d.documentElement.style.setProperty('--proof-h', p + 'px');
      d.documentElement.style.setProperty('--topbar-h', h + 'px');
      d.documentElement.style.scrollPaddingTop = (h ? h + 12 : 0) + 'px';
    }
    measure();
    window.addEventListener('resize', measure);
    if (d.fonts && d.fonts.ready) d.fonts.ready.then(measure);
    setTimeout(measure, 1500);
  }

  /* ---------- "Loved by" bar: count the number up on every page load ---------- */
  function initProof() {
    var root = $('[data-proof]');
    if (!root || !once(root, 'count')) return;
    var el = $('[data-proof-count]', root);
    if (!el) return;
    var raw = (el.textContent || '').trim();
    var m = raw.match(/^([^\d]*)(\d[\d.,\s]*)(.*)$/);
    if (!m) return;
    var lead = m[1], numStr = m[2].replace(/\s+$/, ''), tail = m[3] + (m[2].length > numStr.length ? m[2].slice(numStr.length) : '');
    var decimals = 0;
    var lastDot = numStr.lastIndexOf('.'), lastComma = numStr.lastIndexOf(',');
    var sepIdx = Math.max(lastDot, lastComma);
    if (sepIdx > -1 && numStr.length - sepIdx - 1 !== 3) decimals = numStr.length - sepIdx - 1;
    var target = decimals
      ? parseFloat(numStr.slice(0, sepIdx).replace(/[.,]/g, '') + '.' + numStr.slice(sepIdx + 1))
      : parseInt(numStr.replace(/[.,]/g, ''), 10);
    if (!isFinite(target) || target <= 0 || reduce) return;
    var duration = Math.max(0.5, parseFloat(root.getAttribute('data-duration')) || 2.5) * 1000;
    var fmt;
    try { fmt = new Intl.NumberFormat(d.documentElement.lang || undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals }); }
    catch (e) { return; }
    var text = el.parentNode;
    // hold the final width so the bar does not jiggle while digits change
    el.style.setProperty('--count-w', Math.ceil(el.getBoundingClientRect().width) + 'px');
    var render = function (v) { el.textContent = lead + fmt.format(v) + tail; };
    render(0);
    text.classList.add('is-counting');
    var start = null;
    function easeOut(t) { return 1 - Math.pow(1 - t, 4); }
    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      render(decimals ? Math.round(target * easeOut(t) * Math.pow(10, decimals)) / Math.pow(10, decimals) : Math.round(target * easeOut(t)));
      if (t < 1) requestAnimationFrame(frame);
      else { el.textContent = raw; text.classList.remove('is-counting'); }
    }
    setTimeout(function () { requestAnimationFrame(frame); }, 250);
  }

  /* ---------- Sales popup ---------- */
  function initToast() {
    var toast = $('[data-toast]');
    var dataEl = $('[data-toast-data]');
    if (!toast || !dataEl || !once(toast, 'init')) return;
    var items = [];
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!items.length) return;
    try { if (sessionStorage.getItem('toastDismissed') === '1') return; } catch (e) {}

    var delay = (parseFloat(toast.getAttribute('data-delay')) || 6) * 1000;
    var stay = (parseFloat(toast.getAttribute('data-duration')) || 5) * 1000;
    var gap = (parseFloat(toast.getAttribute('data-gap')) || 9) * 1000;
    var shuffle = toast.getAttribute('data-shuffle') === 'true';

    var avatar = $('[data-toast-avatar]', toast);
    var nameEl = $('[data-toast-name]', toast);
    var actionEl = $('[data-toast-action]', toast);
    var timeEl = $('[data-toast-time]', toast);
    var tones = ['#8c5a3c', '#6b3a22', '#a4785c', '#5c4033', '#b07a50'];

    var order = items.map(function (_, i) { return i; });
    if (shuffle) order.sort(function () { return Math.random() - 0.5; });
    var pos = 0, timer, dismissed = false;

    function fill(it, idx) {
      nameEl.textContent = it.name || '';
      actionEl.textContent = it.action || '';
      timeEl.textContent = it.time || '';
      avatar.innerHTML = '';
      if (it.image) {
        var img = d.createElement('img');
        img.src = it.image; img.alt = ''; img.width = 44; img.height = 44;
        avatar.appendChild(img);
        avatar.style.background = '';
      } else {
        avatar.textContent = (it.name || '?').trim().charAt(0).toUpperCase();
        avatar.style.background = tones[idx % tones.length];
      }
    }
    function show() {
      if (dismissed) return;
      var idx = order[pos % order.length]; pos++;
      fill(items[idx], idx);
      toast.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { toast.classList.add('is-visible'); }); });
      timer = setTimeout(hide, stay);
    }
    function hide() {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.hidden = true;
        if (!dismissed) timer = setTimeout(show, gap);
      }, reduce ? 0 : 550);
    }
    $('[data-toast-close]', toast).addEventListener('click', function () {
      dismissed = true; clearTimeout(timer);
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 450);
      try { sessionStorage.setItem('toastDismissed', '1'); } catch (e) {}
    });
    timer = setTimeout(show, delay);
  }

  /* ---------- Rating under the title: filled from the page's reviews ---------- */
  function initAutoRating() {
    var stats = $('[data-reviews-stats]');
    $$('[data-auto-rating]').forEach(function (row) {
      if (!stats) return;
      var avg = parseFloat(stats.getAttribute('data-avg')) || 0;
      var count = parseInt(stats.getAttribute('data-count'), 10) || 0;
      if (!count) return;
      var round = Math.round(avg);
      $$('.icon', row).forEach(function (ic, i) { ic.classList.toggle('is-off', i + 1 > round); });
      $('[data-auto-rating-text]', row).textContent = avg.toFixed(1) + ' · ' + count + ' review' + (count === 1 ? '' : 's');
      row.hidden = false;
    });
  }

  function init() {
    initAutoRating();
    $$('[data-product]').forEach(function (root) {
      if (!once(root, 'init')) return;
      initGallery(root);
      initVariants(root);
      initBuyNow(root);
      initDelivery(root);
      initSticky(root);
    });
    $$('[data-countdown]').forEach(function (el) { if (once(el, 'init')) initCountdown(el); });
    initTopbar();
    initProof();
    initToast();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', init);
})();
